import React from 'react'
import { useState } from 'react'
import ValueWithEdit from '../../../../UI/table/values/ValueWithEdit'
import MyModal from '../../../../UI/modal/MyModal'
import ChangeNakladnaOriginalForm from './ChangeNakladnaOriginalForm'

const ChangeNakladnaOriginalButton = ({ supplyBill }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <ValueWithEdit
            value={supplyBill.isNakladnaOriginal ? 'Так' : 'Ні'}
            textTooltip={'Редагувати'}
            setOpen={setOpen}
        />

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Редагування отримання накладної'}
            disableClickOutside={true}
            content={
                <ChangeNakladnaOriginalForm
                    supplyBillBd={supplyBill}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default ChangeNakladnaOriginalButton